import {ButtonSize} from './Forms';
import {Mutable} from './Common';

type Steps = {label: string; size: ButtonSize}[];

export const steps = [
    {
        label: 'Commande en cours de validation',
        size: 'medium',
    },
    {
        label: 'En attente de vos informations',
        size: 'medium',
    },
    {
        label: 'Commande validée',
        size: 'medium',
    },
    {
        label: 'Préparation de la mise en production',
        size: 'medium',
    },
    {
        label: 'En attente de votre validation',
        size: 'medium',
    },
    {
        label: 'En cours de production',
        size: 'medium',
    },
    {
        label: 'Livrée',
        size: 'medium',
    },
] as Mutable<Steps>;

type Step = (typeof steps)[number]['label'];

export type {Step};
